export enum PartyRolesEnum {
    Driver = 'IDVR',
    Witness = 'WTNS',
    Contact = 'ACPN',
    CoInsured = 'MEDE',
    CounterParty = 'TEGE',
    Other = 'OVEP',
}
